const TOPICS = [
  { label: '韩漫热门', hot: true, count: '3.2万' },
  { label: '日漫经典', hot: true, count: '4.8万' },
  { label: '国漫崛起', hot: true, count: '2.6万' },
  { label: '热血冒险', hot: false, count: '1.9万' },
  { label: '恋爱甜宠', hot: true, count: '3.5万' },
  { label: '奇幻异界', hot: false, count: '2.1万' },
  { label: '悬疑推理', hot: false, count: '1.4万' },
  { label: '搞笑日常', hot: false, count: '1.8万' },
  { label: '都市情感', hot: true, count: '2.3万' },
  { label: '古风仙侠', hot: false, count: '1.6万' },
  { label: '耽美专区', hot: false, count: '2.7万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          发现当下最受追捧的漫画类型，找到你的阅读兴趣
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              {topic.label}
              <span className={`text-xs ${topic.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}